import PinModal from './PinModal';

export default PinModal;
